/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoMattermostIcon16Light } from './LogoMattermostIcon16Light';
import { LogoMattermostIcon16Regular } from './LogoMattermostIcon16Regular';
import { LogoMattermostIcon16Solid } from './LogoMattermostIcon16Solid';
import { LogoMattermostIcon20Light } from './LogoMattermostIcon20Light';
import { LogoMattermostIcon20Regular } from './LogoMattermostIcon20Regular';
import { LogoMattermostIcon20Solid } from './LogoMattermostIcon20Solid';
import { LogoMattermostIcon24Regular } from './LogoMattermostIcon24Regular';
import { LogoMattermostIcon24Solid } from './LogoMattermostIcon24Solid';
import { LogoMattermostIcon32Regular } from './LogoMattermostIcon32Regular';
import { LogoMattermostIcon64Regular } from './LogoMattermostIcon64Regular';
var sizes = {
    16: {
        light: LogoMattermostIcon16Light,
        regular: LogoMattermostIcon16Regular,
        solid: LogoMattermostIcon16Solid,
    },
    20: {
        light: LogoMattermostIcon20Light,
        regular: LogoMattermostIcon20Regular,
        solid: LogoMattermostIcon20Solid,
    },
    24: {
        regular: LogoMattermostIcon24Regular,
        solid: LogoMattermostIcon24Solid,
    },
    32: {
        regular: LogoMattermostIcon32Regular,
    },
    64: {
        regular: LogoMattermostIcon64Regular,
    },
};
export var LogoMattermostIcon = forwardRef('LogoMattermostIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
